module.exports = "dist/286e1e8d6fc623f0b181e54075308150.ttf";